/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _MedicalHistoryFormComponent;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action } from "@ember/object";
import { ForcModelPojo } from "core/components/forc/abstract/journal-event-based-component";
import BaseMedicalHistoryFormComponent from "core/components/medical-history/abstract/base-edition-form";
import validateSometimes from "core/validators/sometimes";
import dayjs from "dayjs";
import { EmberChangeset } from "ember-changeset";
import { validatePresence } from "ember-changeset-validations/validators";
import { ValidatorMap } from "ember-changeset/types";
import emberSwal from "ui-kit/utils/ember-swal";
let MedicalHistoryFormComponent = (_class = (_MedicalHistoryFormComponent = class MedicalHistoryFormComponent extends BaseMedicalHistoryFormComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "journalEventProperties", [...this.sharedProperties, ...this.diabetePathologyProperties]);
  }
  retrieveModel() {
    const model = super.retrieveModel();
    if (this.isNewMode) {
      model.birthday = this.args.patient.birthday;
      model.age = this.args.patient.patientAge;
    }
    return model;
  }
  get diabetePathologyProperties() {
    return ["birthday", "state", "height", "weight", "year", "hba", "hbaDate", "mrc", "dfg", "rac", "reti", "neur", "mcva", "ic", "oth", "exp", "hta", "met", "isglt2", "arglp1", "fevg", "systolic", "diastolic", "dyslipidemieTreated", "lastDyslipidemie", "smoker", "doSport", "insulin", "idpp4", "familyIcBackground", "albuminuria", "isFollowingDiabetologist"];
  }
  get age() {
    return this.changeset.get("age");
  }
  get validations() {
    return {
      birthday: [validatePresence({
        presence: true,
        description: "La date de naissance du patient"
      })],
      state: validateSometimes([validatePresence({
        presence: true,
        message: "L'état de santé du patient"
      })], function () {
        return this.get("age") >= 75;
      }),
      height: [validatePresence({
        presence: true,
        description: "La taille du patient"
      })],
      weight: [validatePresence({
        presence: true,
        description: "Le poid du patient"
      })],
      year: [validatePresence({
        presence: true,
        description: "L'année du diagnostic du diabète"
      })],
      hba: [validatePresence({
        presence: true,
        description: "Dernier HBA1c connu"
      })],
      hbaDate: [validatePresence({
        presence: true,
        description: "Date de la dernière mesure d'HBA1c"
      })],
      systolic: [validatePresence({
        presence: true,
        description: "La dernière pression artérielle systolique en consultation"
      })],
      diastolic: [validatePresence({
        presence: true,
        description: "La dernière pression artérielle diastolique en consultation"
      })],
      lastDyslipidemie: [validatePresence({
        presence: true,
        description: "La dernière mesure de LDLc"
      })],
      met: [validatePresence({
        presence: true,
        description: "Metformine"
      })],
      isglt2: [validatePresence({
        presence: true,
        description: "ISGLT2"
      })],
      arglp1: [validatePresence({
        presence: true,
        description: "AR GLP-1"
      })],
      smoker: [validatePresence({
        presence: true,
        description: "Fumeur"
      })],
      doSport: [validatePresence({
        presence: true,
        description: "Activités sportives"
      })],
      insulin: [validatePresence({
        presence: true,
        description: "Insuline"
      })],
      idpp4: [validatePresence({
        presence: true,
        description: "iDDP4"
      })]
    };
  }
  updateAge(value) {
    this.changeset.set("birthday", value);
    this.changeset.set("age", dayjs().diff(this.changeset.get("birthday"), "years"));
  }
  get isMissingInformations() {
    const comorbidities = this.comorbiditiesChangeset?.get("comorbidities");
    if (!comorbidities) return false;
    if (comorbidities.includes("N18.9")) {
      if (!this.changeset.get("dfg")) return true;
      if (!this.changeset.get("rac")) return true;
      if (!this.changeset.get("albuminuria")) return true;
    }
    if (comorbidities.includes("I50.9")) {
      if (!this.changeset.get("fevg")) return true;
    }
    if (comorbidities.includes("I10")) if (this.changeset.get("hta") == undefined) return true;
    if (comorbidities.includes("E78.9")) if (this.changeset.get("dyslipidemieTreated") == undefined) return true;
    return false;
  }
  async save() {
    if (this.isMissingInformations) {
      const response = await emberSwal.fire({
        title: "Êtes-vous sûr de vouloir sauvegarder ?",
        text: "Des éléments complémentaires ne sont pas renseignés au niveau des comorbidités et pourraient minorer la recommendation obtenue pour ce patient",
        icon: "warning",
        cancelButtonText: "Annuler",
        showCancelButton: true,
        confirmButtonText: "Oui",
        confirmButtonColor: "#d33"
      });
      if (response.isDismissed) {
        this.afterCompleted = () => {
          this.forceQuit = false;
        };
        return;
      }
    }
    this.afterCompleted = this.args.afterCompleted ? this.args.afterCompleted : () => {
      return;
    };
    const comorbidities = this.comorbiditiesChangeset.get("comorbidities");
    const ignoredComorbidities = this.comorbiditiesChangeset.get("ignoredComorbidities");
    const keysToCode = {
      reti: "H36",
      neur: "G99.0",
      mrc: "N18.9",
      mcva: "I51.6",
      ic: "I50.9",
      oth: "other"
    };
    for (const [key, code] of Object.entries(keysToCode)) {
      this.changeset.set(key, comorbidities?.includes(code) ? "true" : ignoredComorbidities?.includes(code) ? "false" : "unknown");
    }
    const htaValue = !comorbidities?.includes("I10") ? ignoredComorbidities?.includes("I10") ? "no" : "unknown" : this.changeset.get("hta") ?? "treated";
    this.changeset.set("hta", htaValue);
    if (this.changeset.get("birthday") !== this.patient.birthday) {
      this.patient.birthday = this.changeset.get("birthday");
      await this.patient.save();
    }
    await super.save();
  }
}, _defineProperty(_MedicalHistoryFormComponent, "forcDisplayName", "Synthèse médicale – formulaire d’inclusion"), _MedicalHistoryFormComponent), _applyDecoratedDescriptor(_class.prototype, "updateAge", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateAge"), _class.prototype), _class);
export { MedicalHistoryFormComponent as default };